module.exports = __webpack_public_path__ + "img/bul_info_component.523a6e0e.svg";